import { struct } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { Amount } from '@mews-commander/data-access';
import {
    ADVANCE_EXCEPTION_TYPE,
    LENGTH_EXCEPTION_TYPE,
    PRICE_EXCEPTION_TYPE,
    RESERVATION_COUNT_EXCEPTION_TYPE,
    SECONDARY_TIME_UNIT_LENGTH,
} from '../../constants';
import { ProcessedException, Range } from '../../types';

interface ReshapedExceptions {
    [ADVANCE_EXCEPTION_TYPE]: Range<number>;
    [LENGTH_EXCEPTION_TYPE]: Range<number>;
    [PRICE_EXCEPTION_TYPE]: Range<Amount>;
    [RESERVATION_COUNT_EXCEPTION_TYPE]: Range<number>;
    [SECONDARY_TIME_UNIT_LENGTH]?: Range<number>;
}

const groupExceptions = ({
    minAdvance,
    maxAdvance,
    minLength,
    maxLength,
    minPrice,
    maxPrice,
    minReservationCount,
    maxReservationCount,
    secondaryMinLength,
    secondaryMaxLength,
}: ProcessedException): ReshapedExceptions => ({
    [ADVANCE_EXCEPTION_TYPE]: {
        min: minAdvance,
        max: maxAdvance,
    },
    [LENGTH_EXCEPTION_TYPE]: {
        min: minLength,
        max: maxLength,
    },
    [PRICE_EXCEPTION_TYPE]: {
        min: minPrice,
        max: maxPrice,
    },

    [RESERVATION_COUNT_EXCEPTION_TYPE]: {
        min: minReservationCount,
        max: maxReservationCount,
    },
    [SECONDARY_TIME_UNIT_LENGTH]: {
        min: secondaryMinLength,
        max: secondaryMaxLength,
    },
});

const processRange = <T>({ min, max }: Range<T>) => {
    if (min && max) {
        return { min, max };
    }
    if (min) {
        return { min };
    }
    if (max) {
        return { max };
    }
    return undefined;
};

const reshapeExceptionsObject = flow(
    groupExceptions,
    struct.evolve({
        [ADVANCE_EXCEPTION_TYPE]: (range) => processRange(range),
        [LENGTH_EXCEPTION_TYPE]: (range) => processRange(range),
        [PRICE_EXCEPTION_TYPE]: (range) => processRange(range),
        [RESERVATION_COUNT_EXCEPTION_TYPE]: (range) => processRange(range),
        [SECONDARY_TIME_UNIT_LENGTH]: (range) => (range ? processRange(range) : undefined),
    })
);

export default reshapeExceptionsObject;
